import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const saved = localStorage.getItem("samadhan_token");
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

const TASK_URL = /\/dictation\/(transcribe|rewrite|command)$/;
api.interceptors.response.use(
  (res) => {
    if (TASK_URL.test(res.config.url || "")) window.dispatchEvent(new Event("mulankan:task"));
    return res;
  },
  (err) => {
    if (err.response?.status === 402) window.dispatchEvent(new CustomEvent("mulankan:paywall", { detail: err.response.data?.detail }));
    return Promise.reject(err);
  },
);

export const isPaywall = (e) => e?.response?.status === 402;

export function setToken(token) {
  if (token) {
    localStorage.setItem("samadhan_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("samadhan_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
